<script setup lang="ts">
import type { Target, Type } from '~/types'
import { ButtonType } from '~/enums/button-type'
import { LinkTarget } from '~/enums/link-target'

interface Props {
  url?: string
  title?: string
  target?: Target
  type?: Type
}

withDefaults(defineProps<Props>(), {
  url: '#',
  title: 'Read More',
  target: LinkTarget.SELF,
  type: ButtonType.DARK,
})
</script>

<template>
  <a
    v-if="url"
    :href="url"
    :target="target"
    :class="`button button--${type}`"
  >{{ title }}</a>
</template>
